












import { Component, Vue, Prop } from 'vue-property-decorator';
import { Action } from 'vuex-class';
import { GetRequest } from '@/store/requeststate';
import Bookmark from '@/components/bookmark/Bookmark.vue';
import {BookmarkBean} from '@/types';

@Component({
    components: {
        Bookmark,
    },
})
export default class BookmarkColumn extends Vue {
    @Action('get', {namespace: 'requestState'})
    public get!: (req: GetRequest) => Promise<any>;

    @Prop()
    private tag!: string;

    @Prop()
    private list!: BookmarkBean[];

    @Prop()
    private all!: boolean;

    private get filteredList(): BookmarkBean[] {
        if (this.all) {
            return this.list;
        }
        const results: BookmarkBean[] = [];
        for (const bean of this.list) {
            const tags = bean.tags.split(',');
            if (tags.includes(this.tag)) {
                results.push(bean);
            }
        }
        return results;
    }
}
